import React from "react";
import { SignInForm } from "../components/signin/SignInForm";

export function SigninPage(props) {
  return <SignInForm {...props} />;
}
